import {track} from './utils';

const enum Events {
  Activated = `Activated`,
  ClickActivation = `Click Activation`,
  Closed = `User Closed`,
  FacetError = `Facet Error`,
  HotkeyActivation = `Hotkey Activation`,
  ResultsError = `Results Error`,
  ResultClick = `Result Click`,
  Search = `Search`,
  FirstSearch = `First Search`,
  TypeSelected = `Type Selected`,
}

const timingData = {
  firstSearchAt: 0,
  lastSearchAt: 0,
  openedAt: 0,
  searchCount: 0,
};

function timeInSeconds(latest, prev) {
  return (latest - prev) / 1000;
}

export function trackHotKey(projectId, drawerTransitionTo) {
  return track(Events.HotkeyActivation, {
    'Project ID': projectId,
    'Drawer Transitions To': drawerTransitionTo,
  });
}

export function trackClick(projectId, drawerTransitionTo) {
  return track(Events.ClickActivation, {
    'Project ID': projectId,
    'Drawer Transitions To': drawerTransitionTo,
  });
}

export function trackClosed(projectId) {
  return track(Events.Closed, {
    'Project ID': projectId,
  });
  // duration
}

export function trackActivation(projectId) {
  timingData.openedAt = Date.now();
  timingData.searchCount = 0;
  return track(Events.Activated, {
    'Project ID': projectId,
  });
}

export function trackSearch(activeTab, searchText) {
  timingData.searchCount += 1;
  const trackObject = {
    'Selected Type': activeTab,
    'Search String Length': searchText.length,
    'Search String Words': searchText.split(` `).length,
    'Search Count': timingData.searchCount,
  };

  if (!timingData.lastSearchAt) {
    track(Events.FirstSearch, {
      ...trackObject,
      'Time to Search': timeInSeconds(Date.now(), timingData.openedAt),
    });
  } else {
    trackObject[`Time Since Last Search`] = timeInSeconds(Date.now(), timingData.lastSearchAt);
  }
  timingData.lastSearchAt = Date.now();
  return track(Events.Search, trackObject);
}

export function trackResultClick({name, type, link, index, selectedType, count}) {
  return track(Events.ResultClick, {
    'Result Name': name,
    'Result Type': type,
    'Result Link': link,
    'Result Position': index,
    'Results Count': count,
    'Selected Type': selectedType,
    'Time Search to Click': timeInSeconds(Date.now(), timingData.lastSearchAt),
    'Time Activation to Click': timeInSeconds(Date.now(), timingData.openedAt),
  });
}

export function trackResultError(message, searchText) {
  return track(Events.ResultsError, {
    'Error Message': message,
    'Search Text': searchText,
  });
}

export function trackFacetFailure(message) {
  return track(Events.FacetError, {
    'Error Message': message,
  });
}

export function trackTypeChange(newSelection, oldSelection, {oldSelectionCount, newSelectionCount}) {
  return track(Events.TypeSelected, {
    'Selected Type': newSelection,
    'Previous Type': oldSelection,
    Count: newSelectionCount,
    'Previous Count': oldSelectionCount,
  });
}
